var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class WebKitNativeNotifications {
    static GetDeviceFirebaseTokenAsync(timeout = 8000) {
        let timer;
        return new Promise((resolve, reject) => {
            timer = setTimeout(() => {
                reject(null);
            }, timeout);
            try {
                window.nativeEvent.firebase.handleToken = (token) => {
                    clearTimeout(timer);
                    if (token == "")
                        resolve(null);
                    resolve(token);
                };
                window.webkit.messageHandlers.firebaseNotifications.postMessage("GetDeviceFirebaseTokenAsync");
            }
            catch (err) {
                reject(err);
            }
        });
    }
    static GetNativeNotificationsPermissionAsync(timeout = 8000) {
        let timer;
        return new Promise((resolve, reject) => {
            timer = setTimeout(() => {
                reject(null);
            }, timeout);
            try {
                window.nativeEvent.firebase.handlePermissions = (permissions) => {
                    clearTimeout(timer);
                    resolve(permissions);
                };
                window.webkit.messageHandlers.firebaseNotifications.postMessage("CheckNotificationsPermissions");
            }
            catch (err) {
                reject(err);
            }
        });
    }
    static GetNativeNotificationsQueueAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!WebKitNativeNotifications._queueInstance) {
                WebKitNativeNotifications._queueInstance = new IosNotificationQueue();
            }
            return WebKitNativeNotifications._queueInstance;
        });
    }
}
WebKitNativeNotifications._queueInstance = null;
export class IosNotificationQueue {
    constructor() {
        window.addEventListener('notificationQueueUpdate', this.handleNativeUpdate.bind(this));
    }
    handleNativeUpdate(e) {
        var _a;
        const ev = e;
        const info = ev.detail;
        (_a = this.OnNotificationsRecived) === null || _a === void 0 ? void 0 : _a.call(this, info);
    }
    GetNotificationsFromQueueAsync(timeout = 8000) {
        return __awaiter(this, void 0, void 0, function* () {
            let timer;
            return new Promise((resolve, reject) => {
                timer = setTimeout(() => {
                    reject(null);
                }, timeout);
                try {
                    window.nativeEvent.firebase.handleNotificationsFromQueue = (notifications) => {
                        clearTimeout(timer);
                        if (notifications == null || notifications.length == 0 || Array.isArray(notifications) == false)
                            resolve([]);
                        resolve(notifications);
                    };
                    window.webkit.messageHandlers.firebaseNotifications.postMessage("GetAllNotificationsFromQueueAsync");
                }
                catch (err) {
                    reject(err);
                }
            });
        });
    }
    GetNotificationByGuidAsync(guid, timeout = 8000) {
        let timer;
        return new Promise((resolve, reject) => {
            timer = setTimeout(() => {
                reject(null);
            }, timeout);
            try {
                window.nativeEvent.firebase.handleNotificationFromQueue = (notification) => {
                    clearTimeout(timer);
                    resolve(notification);
                };
                var data = {
                    command: "GetNotificationByGuidAsync",
                    data: guid
                };
                window.webkit.messageHandlers.firebaseNotifications.postMessage(data);
            }
            catch (err) {
                reject(err);
            }
        });
    }
}
//# sourceMappingURL=NativeNotifications.js.map